// Reminder presets and labels for private to-dos (all in the user's local time).
const at9 = (d) => { d.setHours(9, 0, 0, 0); return d; };

export const REMINDER_PRESETS = [
  { key: "1h", label: "In 1 hour", at: () => new Date(Date.now() + 3600000) },
  { key: "3h", label: "In 3 hours", at: () => new Date(Date.now() + 3 * 3600000) },
  { key: "tomorrow", label: "Tomorrow 9:00 am", at: () => { const d = new Date(); d.setDate(d.getDate() + 1); return at9(d); } },
  { key: "monday", label: "Next Monday 9:00 am", at: () => { const d = new Date(); d.setDate(d.getDate() + (((8 - d.getDay()) % 7) || 7)); return at9(d); } },
];

export const REPEATS = [
  { key: "daily", short: "Daily", label: "Every day" },
  { key: "weekdays", short: "Weekdays", label: "Every weekday" },
  { key: "weekly", short: "Weekly", label: "Every week" },
  { key: "biweekly", short: "2 weeks", label: "Every 2 weeks" },
  { key: "monthly", short: "Monthly", label: "Every month" },
];
export const repeatLabel = (key) => REPEATS.find((r) => r.key === key)?.label;
export const localTz = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

export const SNOOZES = [
  { key: "10m", label: "10 min", at: () => new Date(Date.now() + 600000) },
  { key: "1h", label: "1 hour", at: () => new Date(Date.now() + 3600000) },
  REMINDER_PRESETS[2],
];

// "Today 3:00 PM", "Tomorrow 9:00 AM", "Mon 9:00 AM" or "Oct 30, 9:00 AM".
export function reminderLabel(iso) {
  const d = new Date(iso);
  const time = d.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
  const day = (x) => new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
  const diff = Math.round((day(d) - day(new Date())) / 86400000);
  if (diff === 0) return `Today ${time}`;
  if (diff === 1) return `Tomorrow ${time}`;
  if (diff === -1) return `Yesterday ${time}`;
  if (diff > 1 && diff < 7) return `${d.toLocaleDateString(undefined, { weekday: "short" })} ${time}`;
  return `${d.toLocaleDateString(undefined, { month: "short", day: "numeric" })}, ${time}`;
}

// Value for <input type="datetime-local"> in local time.
export const toLocalInput = (d) => new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);

// Tell the panel and the reminder host that to-dos changed somewhere else.
export const CHECKLISTS_CHANGED = "vektor:checklists-changed";
export const announceChecklistsChanged = () => window.dispatchEvent(new Event(CHECKLISTS_CHANGED));
